__turbopack_context__.v({
  "body": "_9aaUfW_body",
  "content": "_9aaUfW_content",
  "modal": "_9aaUfW_modal",
  "root": "_9aaUfW_root",
  "scrollContainer": "_9aaUfW_scrollContainer",
  "tab": "_9aaUfW_tab",
  "tabs": "_9aaUfW_tabs",
  "title": "_9aaUfW_title",
});
